export function createInitialHashScroller(timeout = 1000) {
  let observer: MutationObserver;
  let timeoutId: number | null;

  if (!window.MutationObserver) {
    return;
  }

  const reset = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    if (observer) {
      observer.disconnect();
    }
  };

  const createScrollToElement = (id: string) => {
    return () => {
      const element = document.getElementById(id);

      if (element) {
        window.setTimeout(() => element.scrollIntoView({ behavior: "smooth" }), 200);

        reset();

        return true;
      }

      return false;
    };
  };

  const elementId = location.hash.slice(1);
  if (!elementId) {
    return;
  }

  const scrollToElement = createScrollToElement(elementId);

  window.setTimeout(() => {
    if (scrollToElement()) {
      return;
    }

    observer = new MutationObserver(scrollToElement);

    observer.observe(document, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    timeoutId = window.setTimeout(reset, timeout) as unknown as number;
  });
}
